import './Terms.css';
/* MUI */
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

function Terms() {
  return (
    <div className="App">
      <main>
        <Container maxWidth="lg" sx={{textAlign: 'left', pb: 4}}>
          <Typography variant="h1" sx={{pt: 3}}>
            Terms
          </Typography>
          <Typography variant="p">
               These terms and conditions govern your use of this website; by using this website, you accept these terms and conditions in full.   If you disagree with these terms and conditions or any part of these terms and conditions, you must not use this website. 
          </Typography>
          <Typography variant="p">
               This website uses cookies.  By using this website and agreeing to these terms and conditions, you consent to our Four Letter Data's use of cookies in accordance with the terms of Four Letter Data's privacy policy.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>
               License to use website
          </Typography>
          <Typography variant="p">
               Unless otherwise stated, Four Letter Data and/or its licensors own the intellectual property rights in the website and material on the website.  Subject to the license below, all these intellectual property rights are reserved.
          </Typography>
          <Typography variant="p">
               You may view, download for caching purposes only, and print pages from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.  
          </Typography>
          <Typography variant="p">
          You must not:
          <ul>
          <li>republish material from this website (including republication on another website);</li>
          <li>sell, rent or sub-license material from the website;</li>
          <li>show any material from the website in public;</li>
          <li>reproduce, duplicate, copy or otherwise exploit material on this website for a commercial purpose;</li>
          <li>edit or otherwise modify any material on the website; or</li>
          <li>redistribute material from this website.</li>
          </ul>
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Acceptable use</Typography>
          <Typography variant="p">
               You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
          </Typography>
          <Typography variant="p">
               You must not use this website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
          </Typography>
          <Typography variant="p">
               You must not conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to this website without Four Letter Data's express written consent.
          </Typography>
          <Typography variant="p">
               You must not use this website to transmit or send unsolicited commercial communications.
          </Typography>
          <Typography variant="p">
               You must not use this website for any purposes related to marketing without Four Letter Data's express written consent.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Restricted access</Typography>
          <Typography variant="p">
               Access to certain areas of this website is restricted.  Four Letter Data reserves the right to restrict access to other areas of this website, or indeed this entire website, at Four Letter Data’s discretion.
          </Typography>
          <Typography variant="p">
               Four Letter Data may disable your user ID and password in Four Letter Data’s sole discretion without notice or explanation.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>User content</Typography>
          <Typography variant="p">
               In these terms and conditions, "your user content" means material (including without limitation text, images, audio material, video material and audio-visual material) that you submit to this website, for whatever purpose.
          </Typography>
          <Typography variant="p">
          You grant to Four Letter Data a worldwide, irrevocable, non-exclusive, royalty-free license to use, reproduce, adapt, publish, translate and distribute your user content in any existing or future media.  You also grant to Four Letter Data the right to sub-license these rights, and the right to bring an action for infringement of these rights.
          </Typography>
          <Typography variant="p">
               Your user content must not be illegal or unlawful, must not infringe any third party's legal rights, and must not be capable of giving rise to legal action whether against you or Four Letter Data or a third party (in each case under any applicable law).  
          </Typography>
          <Typography variant="p">
               You must not submit any user content to the website that is or has ever been the subject of any threatened or actual legal proceedings or other similar complaint.
          </Typography>
          <Typography variant="p">
               Four Letter Data reserves the right to edit or remove any material submitted to this website, or stored on Four Letter Data’s servers, or hosted or published upon this website.
          </Typography>
          <Typography variant="p">
               Notwithstanding Four Letter Data's rights under these terms and conditions in relation to user content, Four Letter Data does not undertake to monitor the submission of such content to, or the publication of such content on, this website.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>No warranties</Typography>
          <Typography variant="p">
               This website is provided "as is" without any representations or warranties, express or implied.  Four Letter Data makes no representations or warranties in relation to this website or the information and materials provided on this website.  
          </Typography>
          <Typography variant="p">
               Without prejudice to the generality of the foregoing paragraph, Four Letter Data does not warrant that:
          </Typography>
          <ul>
          <li>this website will be constantly available, or available at all; or</li>
          <li>the information on this website is complete, true, accurate or non-misleading.</li>
          </ul>
          <Typography variant="p">
               Nothing on this website constitutes, or is meant to constitute, advice of any kind.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Limitations of liability</Typography>
          <Typography variant="p">
               Four Letter Data will not be liable to you (whether under the law of contact, the law of torts or otherwise) in relation to the contents of, or use of, or otherwise in connection with, this website:
          </Typography>
          <ul>
          <li>to the extent that the website is provided free-of-charge, for any direct loss;</li>
          <li>for any indirect, special or consequential loss; or</li>
          <li>for any business losses, loss of revenue, income, profits or anticipated savings, loss of contracts or business relationships, loss of reputation or goodwill, or loss or corruption of information or data.</li>
          </ul>
          <Typography variant="p">
               These limitations of liability apply even if Four Letter Data has been expressly advised of the potential loss.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Exceptions</Typography>
          <Typography variant="p">
               Nothing in this website disclaimer will exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; and nothing in this website disclaimer will exclude or limit Four Letter Data’s liability in respect of any:
          </Typography>
          <ul>
          <li>death or personal injury caused by Four Letter Data’s negligence;</li>
          <li>fraud or fraudulent misrepresentation on the part of Four Letter Data; or</li>
          <li>matter which it would be illegal or unlawful for Four Letter Data to exclude or limit, or to attempt or purport to exclude or limit, its liability.</li>
          </ul>

          <Typography variant="h6" sx={{pt: 1}}>Reasonableness</Typography>
          <Typography variant="p">
               By using this website, you agree that the exclusions and limitations of liability set out in this website disclaimer are reasonable.  
          </Typography>
          <Typography variant="p">
               If you do not think they are reasonable, you must not use this website.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Other parties</Typography>
          <Typography variant="p">
               You agree that the limitations of warranties and liability set out in this website disclaimer will protect Four Letter Data’s officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as Four Letter Data.
          </Typography>

          <Typography variant="h6" sx={{pt: 1}}>Unenforceable provisions</Typography>
          <Typography variant="p">
               If any provision of this website disclaimer is, or is found to be, unenforceable under applicable law, that will not affect the enforceability of the other provisions of this website disclaimer.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Indemnity</Typography>
          <Typography variant="p">
               You hereby indemnify Four Letter Data and undertake to keep Four Letter Data indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by Four Letter Data to a third party in settlement of a claim or dispute on the advice of Four Letter Data’s legal advisers) incurred or suffered by Four Letter Data arising out of any breach by you of any provision of these terms and conditions, or arising out of any claim that you have breached any provision of these terms and conditions.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Breaches of these terms and conditions</Typography>
          <Typography variant="p">
               Without prejudice to Four Letter Data’s other rights under these terms and conditions, if you breach these terms and conditions in any way, Four Letter Data may take such action as Four Letter Data deems appropriate to deal with the breach, including suspending your access to the website, prohibiting you from accessing the website, blocking computers using your IP address from accessing the website, contacting your internet service provider to request that they block your access to the website and/or bringing court proceedings against you.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Variation</Typography>
          <Typography variant="p">
               Four Letter Data may revise these terms and conditions from time-to-time.  Revised terms and conditions will apply to the use of this website from the date of the publication of the revised terms and conditions on this website.  Please check this page regularly to ensure you are familiar with the current version.
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Assignment</Typography>
          <Typography variant="p">
               Four Letter Data may transfer, sub-contract or otherwise deal with Four Letter Data’s rights and/or obligations under these terms and conditions without notifying you or obtaining your consent.
          </Typography>
          <Typography variant="p">
               You may not transfer, sub-contract or otherwise deal with your rights and/or obligations under these terms and conditions.  
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Severability</Typography>
          <Typography variant="p">
               If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect.  If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect. 
          </Typography>
          <Typography variant="h6" sx={{pt: 1}}>Entire agreement</Typography>
          <Typography variant="p">
               These terms and conditions constitute the entire agreement between you and Four Letter Data in relation to your use of this website, and supersede all previous agreements in respect of your use of this website.
          </Typography>
        </Container>
      </main>
    </div>
  );
}

export default Terms;
